import * as React from 'react';
import { withNativeProps } from '@/utils/with-native-props';
import { CnSafeArea } from '@/components/cn-safe-area';
import { usePageFooterHeight } from './hooks/use-page-footer-height';
import './index.scss';
export const CnPageFooter = (props) => {
    const { id, leftSlot, middleSecondarySlot, middleSlot, rightSlot } = props;
    const ref = React.useRef(null);
    usePageFooterHeight({ ref });
    return withNativeProps(props, React.createElement("div", { ref: ref, id: id, className: "cn-ui-m-page-footer" },
        React.createElement("div", { className: "cn-ui-m-page-footer-content" },
            leftSlot,
            middleSecondarySlot,
            middleSlot,
            props.children,
            rightSlot),
        React.createElement(CnSafeArea, null)));
};
CnPageFooter.displayName = 'CnPageFooter';
